(() => {
  const key = 'bagmagnet.wishlist';
  const page = document.querySelector('.wishlist-page');
  const list = page?.querySelector('.wishlist-items');
  const heading = page?.querySelector('h1');
  let items = readItems();

  function readItems() {
    try {
      const saved = JSON.parse(localStorage.getItem(key));
      return new Map(Array.isArray(saved) ? saved : []);
    } catch {
      return new Map();
    }
  }

  function syncButtons(root = document) {
    for (const button of root.querySelectorAll('.wishlist-save')) {
      button.setAttribute('aria-pressed', String(items.has(button.dataset.wishlistId)));
      button.hidden = false;
    }
  }

  function renderList() {
    if (!list) return;
    list.replaceChildren();
    for (const [id, item] of items) {
      if (typeof item?.url !== 'string' || !/^\/(?![\/\\])/.test(item.url)) continue;
      const row = document.createElement('li');
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title;
      const productUrl = new URL(link.href);
      productUrl.pathname += '.js';
      productUrl.search = '';
      productUrl.hash = '';
      fetch(productUrl)
        .then(response => response.ok ? response.json() : null)
        .then(product => {
          if (!product?.featured_image || !link.isConnected) return;
          const imageUrl = new URL(product.featured_image, location.href);
          imageUrl.searchParams.set('width', '640');
          const image = document.createElement('img');
          image.src = imageUrl.href;
          image.alt = '';
          image.width = 320;
          image.height = 320;
          image.loading = 'lazy';
          image.addEventListener('error', () => image.remove(), { once: true });
          link.prepend(image);
        })
        .catch(() => {});
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Remove';
      remove.setAttribute('aria-label', 'Remove ' + item.title + ' from wishlist');
      remove.addEventListener('click', () => {
        const nextRow = row.nextElementSibling || row.previousElementSibling;
        const nextLink = nextRow?.querySelector('a')?.getAttribute('href');
        items.delete(id);
        update();
        const next = [...list.querySelectorAll('a')].find(link => link.getAttribute('href') === nextLink);
        (next || heading).focus();
      });
      row.append(link, remove);
      list.append(row);
    }
    page.querySelector('.wishlist-empty').hidden = list.children.length > 0;
  }

  function update() {
    try {
      localStorage.setItem(key, JSON.stringify([...items]));
    } catch {
      // Keep the wishlist usable on this page when storage is unavailable.
    }
    syncButtons();
    renderList();
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('.wishlist-save');
    if (!button) return;
    const { wishlistId, wishlistTitle, wishlistUrl } = button.dataset;
    if (items.has(wishlistId)) {
      items.delete(wishlistId);
    } else {
      items.set(wishlistId, { title: wishlistTitle, url: wishlistUrl });
    }
    update();
  });

  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    items = readItems();
    syncButtons();
    renderList();
  });

  syncButtons();
  renderList();
  // Collection filters and recommendations can replace cards after page load.
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.matches('.wishlist-save')) {
          syncButtons(node.parentElement || document);
        } else {
          syncButtons(node);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
